import AllIcons from "@Assets/images/IconsEmotionDictionaryKey.json";
import { getSessionId } from "@redux/memoizedSelectors";
import { RestrictUserAccess } from "@utils/helpers";
import { currentWorkspaceId } from "index";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomTooltip from "shared/components/CustomTooltip";
import { useImages } from "shared/dynamic-imports";
import { IconDispatcher } from "shared/ui-basics/index";
import styled, { css } from "styled-components/macro";


export const IconDisplay = ({ icon, index, deleteIcon }) => {
	const current_user = useSelector((state) => state.maps.currentUser);
	const hideForPdf = useLocation().search.getAllMapsParams().hideForPdf;
	const iconLibraries = useSelector((state) => state.libraries.icons?.find((ic) => Number(ic.number) === Number(icon)));
	const sessionId = useSelector(getSessionId);
	const isEmotion = (Number(icon) > 30 && Number(icon) < 61) || (Number(icon) > 89 && Number(icon) < 96);
	const { emotions, icons } = useImages();

	let IconComponent;
	let isCustom = false;
	if (iconLibraries?.isCustom) {
		IconComponent = `api/icon/getCustomImage?iconIdStr=${iconLibraries.id}&sid=${sessionId}&workspaceId=${currentWorkspaceId}`;
		isCustom = true;
	} else {
		const iconSet = isEmotion ? emotions : icons;
		IconComponent = iconSet && AllIcons?.[Number(icon)] && iconSet[AllIcons[Number(icon)]]?.default;
	}

	const DeleteAction = (e) => {
		e.stopPropagation();
		e.preventDefault();
		deleteIcon(icon);
	};

	if (!IconComponent) return <></>;

	return (
		<IconContainer key={icon} access={current_user?.roleName?.toLowerCase()} isCustom={iconLibraries?.isCustom} icon={isCustom || !isEmotion}>
			<IconItem>
				<CustomTooltip text={iconLibraries?.name} disabled={!isEmotion}>
					<img src={IconComponent} key={index} loading={!hideForPdf && isCustom ? "lazy" : "eager"} alt="" />
				</CustomTooltip>
			</IconItem>
			<RemoveIconAction onClick={DeleteAction}>{IconDispatcher("REMOVE")}</RemoveIconAction>
		</IconContainer>
	);
};
const IconItem = styled.div`
${props => !props?.access && css`
pointer-events: none;`};
display: flex;
opacity:1;
`
const RemoveIconAction = styled.button`
	background: transparent;
	border: none;
	position: absolute;
	top: -10px;
	right: -10px;
	cursor: pointer;
	border-radius: 50%;
	top: 0%;
	transform: translate(0px, -3px);
	border: 1px solid #dee2e6;
	background: #ffffff;
	width: 18px;
	font-size: 0.8rem;
	display: flex;
	justify-content: center;
	align-items: center;
	visibility: hidden;
	z-index: 2;

	&:hover {
		color: #ff0000;
	}
`;
const IconContainer = styled.div`
	border-radius: 50%;
	z-index: 1;
	position: relative;
	right: -2%;
	width: 24px;
	height: 24px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0 2px;
	& img {
		width: 24px;
		height: 24px;
		z-index: 2;
	}
	${(props) =>
		props.icon &&
		css`
			background: #ffffff;
			border: 1px solid #dee2e6;
			width: 24px;
			height: 24px;
			& img {
				width: 14px;
				height: 14px;
			}
		`}

	&:hover ${RemoveIconAction} {
		${(props) => (RestrictUserAccess(props.access, ["viewer", "contributor"]) ? "" : " visibility : inherit;")}

		display: flex;
		transform: translate(-5px, -5px);
	}
`;
